export function checkServerError(status) {
  const statusCode = [500, 501, 502, 503, 504, 507];
  if (statusCode.includes(status)) return true;
  else return false;
}
